/*
These are mostly pulled from the .gitlab-ci.yml or other GitLab environment variables. 
WebPack will replace these at build time.
In local build, the defaults and .env files will be used.
*/

module.exports = {
  api_url: process.env.API_URL,
  carbon_app_api_key: process.env.CARBON_APP_API_KEY,
  x_merchant_code: process.env.X_MERCHANT_CODE,
  stripe_api_key: process.env.STRIPE_CLIENT_ID,
  quote_currency: process.env.QUOTE_CURRENCY,
  mass_unit: process.env.MASS_UNIT,
  carbon_uid: process.env.CARBON_UID,
  customer_id: process.env.CUSTOMER_ID,
  geo_location_key: process.env.GEO_LOCATION_KEY,
  cognito_userPoolId: process.env.COGNITO_USER_POOL_ID,
  cognito_userPoolWebClientId: process.env.COGNITO_USER_POOL_CLIENT_ID, //cognito-app-authentication-userPool
  cognito_guestUserPoolId: process.env.COGNITO_GUEST_USER_POOL_ID, //cognito-api-authentication-userPool
  cognito_guestUserPoolWebClientId: process.env.COGNITO_GUEST_USER_POOL_CLIENT_ID,
};
